"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3702],{

/***/ "./src/components/WikiImage.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ WikiImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _components_Elements_Image_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/components/Elements/Image/Image.tsx");



const PLACEHOLDER_IMAGE = "/images/defaults/broken-image.png";
const shimmer = (w, h)=>'\n<svg width="'.concat(w, '" height="').concat(h, '" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n  <defs>\n    <linearGradient id="g">\n      <stop stop-color="#F9D1F4" offset="20%" />\n      <stop stop-color="#F399E8" offset="50%" />\n      <stop stop-color="#F9D1F4" offset="70%" />\n    </linearGradient>\n  </defs>\n  <rect width="').concat(w, '" height="').concat(h, '" fill="#F9D1F4" />\n  <rect id="r" width="').concat(w, '" height="').concat(h, '" fill="url(#g)" />\n  <animate xlink:href="#r" attributeName="x" from="-').concat(w, '" to="').concat(w, '" dur="1s" repeatCount="indefinite"  />\n</svg>');
const toBase64 = (str)=> false ? 0 : window.btoa(str);
const WikiImage = (param)=>{
    let { imageURL , ...rest } = param;
    const [src, setSrc] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(imageURL || PLACEHOLDER_IMAGE);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setSrc(imageURL || PLACEHOLDER_IMAGE);
    }, [
        imageURL
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Elements_Image_Image__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .E, {
        src: src,
        placeholder: "blur",
        onError: ()=>setSrc(PLACEHOLDER_IMAGE),
        blurDataURL: "data:image/svg+xml;base64,".concat(toBase64(shimmer(700, 475))),
        ...rest
    });
};


/***/ }),

/***/ "./src/data/WikiLinks.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ LINK_OPTIONS; },
  "U": function() { return /* binding */ LinkType; }
});

// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__("./node_modules/react-icons/ai/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
;// CONCATENATED MODULE: ./src/components/Icons/coingecko.tsx



const CoinGeckoIcon = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Icon */.JO, {
        viewBox: "0 0 24 24",
        fill: "currentcolor",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_4840_35888)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12 6.14306C12.5406 6.17558 14.4955 6.7087 15 7C14.5796 5.97478 13.1645 5.83832 12 6.14306Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12 9.5C12 9.79667 11.912 10.0867 11.7472 10.3334C11.5824 10.58 11.3481 10.7723 11.074 10.8858C10.7999 10.9993 10.4983 11.0291 10.2074 10.9712C9.91639 10.9133 9.64912 10.7704 9.43934 10.5607C9.22956 10.3509 9.0867 10.0836 9.02882 9.79263C8.97094 9.50166 9.00065 9.20006 9.11418 8.92597C9.22771 8.65189 9.41997 8.41762 9.66664 8.2528C9.91332 8.08797 10.2033 8 10.5 8C10.8978 8 11.2794 8.15804 11.5607 8.43934C11.842 8.72064 12 9.10218 12 9.5Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.9468 0.000117761C9.5735 0.0106318 7.25658 0.724685 5.28905 2.05198C3.32153 3.37928 1.79177 5.2602 0.893238 7.4569C-0.00529779 9.65361 -0.23226 12.0674 0.241051 14.3931C0.714362 16.7188 1.86669 18.8519 3.55231 20.5227C5.23794 22.1935 7.38115 23.3269 9.71094 23.7797C12.0407 24.2324 14.4524 23.9841 16.6411 23.0662C18.8298 22.1482 20.6971 20.6019 22.007 18.6227C23.3168 16.6436 24.0104 14.3204 23.9999 11.9471V11.9471C23.9929 10.3712 23.6757 8.81214 23.0662 7.35889C22.4567 5.90564 21.5669 4.58668 20.4477 3.47729C19.3285 2.36791 18.0017 1.48985 16.5431 0.893233C15.0845 0.296618 13.5227 -0.00686342 11.9468 0.000117761V0.000117761ZM18.339 13.4514C19.0025 13.1775 19.659 12.8601 20.2242 12.4079L20.2477 12.4349C19.7077 12.9271 19.0651 13.2914 18.4112 13.6132C17.7492 13.9271 17.0592 14.1784 16.3503 14.3636C15.6408 14.5471 14.9008 14.6853 14.1512 14.6175C13.4016 14.5497 12.6355 14.2949 12.139 13.7332L12.1625 13.7062C12.7712 14.101 13.4738 14.2401 14.1729 14.2601C14.8816 14.2819 15.5904 14.2236 16.286 14.0862C16.9886 13.9389 17.6759 13.7264 18.339 13.4514V13.4514ZM17.6434 11.414C17.6429 11.322 17.6696 11.2319 17.7203 11.1551C17.771 11.0783 17.8433 11.0183 17.9281 10.9826C18.013 10.9469 18.1064 10.9372 18.1968 10.9547C18.2871 10.9721 18.3703 11.0159 18.4357 11.0806C18.5011 11.1453 18.5459 11.228 18.5643 11.3181C18.5828 11.4083 18.5741 11.5018 18.5394 11.587C18.5046 11.6722 18.4454 11.7452 18.3692 11.7968C18.293 11.8483 18.2032 11.8761 18.1112 11.8766C17.9885 11.8762 17.8709 11.8274 17.784 11.7407C17.697 11.6541 17.6478 11.5367 17.6468 11.414H17.6434ZM10.426 11.414C10.0015 11.4144 9.58649 11.2888 9.23338 11.0533C8.88027 10.8178 8.60493 10.4828 8.44218 10.0908C8.27943 9.69881 8.23658 9.26734 8.31905 8.85097C8.40152 8.4346 8.6056 8.05204 8.9055 7.75166C9.20539 7.45128 9.58762 7.24658 10.0039 7.16343C10.4201 7.08029 10.8516 7.12244 11.2439 7.28455C11.6362 7.44667 11.9716 7.72147 12.2077 8.0742C12.4438 8.42693 12.57 8.84175 12.5703 9.26621C12.571 9.83508 12.3458 10.381 11.9442 10.7839C11.5426 11.1868 10.9975 11.4137 10.4286 11.4149L10.426 11.414ZM13.9668 22.9288V22.9227C13.5051 19.6758 16.3477 16.4949 17.9425 14.8697C18.3016 14.5053 18.8521 14.0053 19.3677 13.474C21.4616 11.5253 21.8895 9.1949 17.6286 8.03403C16.8234 7.80099 15.9886 7.47055 15.1434 7.13664C15.0947 6.92447 14.9068 6.66012 14.5268 6.33751C13.9747 5.85838 12.9373 5.87055 12.0408 6.08273C11.0512 5.84968 10.0738 5.76707 9.13554 5.99577C5.05641 7.11925 4.37467 9.1036 4.20858 11.494C3.98858 14.1271 3.86598 16.0792 2.86858 18.314C1.72088 16.6521 1.04841 14.7085 0.923632 12.6926C0.798858 10.6768 1.22651 8.66506 2.16051 6.87427C3.0945 5.08348 4.49944 3.58149 6.22395 2.53013C7.94845 1.47877 9.92715 0.917901 11.9468 0.907944H11.9512C14.7276 0.896139 17.4076 1.92534 19.4625 3.7925C21.5174 5.65965 22.7978 8.22914 23.0512 10.994C23.3046 13.7589 22.5125 16.5183 20.8313 18.7279C19.1501 20.9374 16.7018 22.4366 13.9695 22.9297L13.9668 22.9288Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4840_35888",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var coingecko = (CoinGeckoIcon);

;// CONCATENATED MODULE: ./src/components/Icons/coinmarketcap.tsx



const CoinMarketCap = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
        fill: "currentcolor",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M20.8644 14.3407C20.6745 14.4696 20.4528 14.5457 20.2227 14.5609C19.9926 14.5762 19.7625 14.53 19.5568 14.4272C19.0739 14.1584 18.8137 13.528 18.8137 12.669V10.0363C18.8137 8.7725 18.3057 7.87331 17.456 7.6292C16.0199 7.21514 14.9475 8.94863 14.5336 9.60062L11.9937 13.6516V8.70761C11.9655 7.5674 11.5892 6.88451 10.8774 6.68057C10.4071 6.54461 9.70159 6.60023 9.01489 7.63229L3.33629 16.6149C2.58073 15.1904 2.18897 13.6058 2.19493 11.9985C2.19493 6.58478 6.58479 2.18154 11.9937 2.18154C17.4027 2.18154 21.8082 6.58478 21.8082 11.9985V12.0263C21.8082 12.0263 21.8082 12.0448 21.8082 12.0541C21.8615 13.1016 21.5166 13.9359 20.8675 14.3407H20.8644ZM24 12.0015V11.949C23.9561 5.35187 18.5879 0 11.9937 0C5.39953 0 0 5.38277 0 11.9985C0 18.6141 5.38072 24 11.9937 24C15.0267 23.9999 17.9444 22.8542 20.1463 20.7988C20.3601 20.6003 20.4858 20.3269 20.4964 20.0377C20.507 19.7485 20.4015 19.4668 20.2028 19.2538C20.1077 19.1501 19.9927 19.066 19.8645 19.0063C19.7364 18.9466 19.5974 18.9125 19.4558 18.9059C19.3142 18.8993 19.1726 18.9203 19.0393 18.9678C18.9059 19.0153 18.7835 19.0884 18.6789 19.1827C17.7308 20.0689 16.6109 20.7571 15.3862 21.2062C14.1616 21.6552 12.8574 21.8557 11.5522 21.7957C10.2469 21.7357 8.96742 21.4163 7.79052 20.8568C6.61361 20.2974 5.56357 19.5093 4.70342 18.54L9.81448 10.4442V14.18C9.81448 15.9753 10.52 16.5562 11.1126 16.7262C11.7053 16.8961 12.6114 16.7787 13.5615 15.2584L16.3836 10.7563C16.4714 10.611 16.556 10.4874 16.6313 10.3793V12.669C16.6313 14.3469 17.3149 15.6879 18.5127 16.3492C19.0573 16.6389 19.6711 16.7789 20.2895 16.7544C20.908 16.73 21.5084 16.542 22.0277 16.2101C23.3447 15.3666 24.0627 13.8401 23.9875 12.0015H24Z"
        })
    });
};
/* harmony default export */ var coinmarketcap = (CoinMarketCap);

;// CONCATENATED MODULE: ./src/components/Icons/twitterIcon.tsx



const TwitterIcon = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
        viewBox: "1 -2 20 20",
        fill: "currentcolor",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M21.1603 2.65593C20.3969 2.99362 19.5873 3.2154 18.7583 3.31393C19.6321 2.79136 20.2861 1.96894 20.5983 0.999927C19.7783 1.48793 18.8793 1.82993 17.9423 2.01493C17.313 1.34151 16.4787 0.89489 15.5693 0.744511C14.6599 0.594133 13.7263 0.748418 12.9136 1.18338C12.1009 1.61834 11.4547 2.30961 11.0755 3.14972C10.6962 3.98983 10.6051 4.93171 10.8163 5.82893C9.15345 5.74558 7.52668 5.31345 6.04163 4.56059C4.55659 3.80773 3.24647 2.75097 2.19634 1.45893C1.82463 2.09738 1.6293 2.82315 1.63034 3.56193C1.63034 5.01193 2.36834 6.29293 3.49034 7.04293C2.82635 7.02202 2.17698 6.84271 1.59634 6.51993V6.57193C1.59654 7.53763 1.93071 8.47354 2.54219 9.22099C3.15367 9.96843 4.00483 10.4814 4.95134 10.6729C4.33496 10.84 3.68865 10.8646 3.06134 10.7449C3.32821 11.5762 3.84835 12.3031 4.54894 12.824C5.24952 13.3449 6.09547 13.6337 6.96834 13.6499C6.10082 14.3313 5.10752 14.8349 4.04522 15.1321C2.98293 15.4293 1.87247 15.5142 0.777344 15.3819C2.68904 16.6114 4.91444 17.264 7.18734 17.2619C14.8803 17.2619 19.0873 10.8889 19.0873 5.36193C19.0873 5.18193 19.0823 4.99993 19.0743 4.82193C19.8932 4.23009 20.5999 3.49695 21.1613 2.65693L21.1603 2.65593Z"
        })
    });
};
/* harmony default export */ var twitterIcon = (TwitterIcon);

;// CONCATENATED MODULE: ./src/components/Icons/redditIcon.tsx



const RedditIcon = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
        viewBox: "0 0 20 20",
        fill: "currentcolor",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM16.67 10C16.6597 9.71852 16.5682 9.44602 16.4066 9.21537C16.2449 8.98471 16.02 8.80575 15.7589 8.70005C15.4978 8.59434 15.2117 8.56642 14.9351 8.61964C14.6585 8.67286 14.4032 8.80496 14.2 9C13.0624 8.22671 11.7252 7.7995 10.35 7.77L11 4.65L13.14 5.1C13.1654 5.33648 13.2743 5.55615 13.4471 5.71958C13.6199 5.88301 13.8453 5.9795 14.0829 5.99172C14.3204 6.00394 14.5545 5.9311 14.7432 5.78626C14.9319 5.64143 15.0627 5.4341 15.1123 5.20147C15.1619 4.96885 15.1269 4.72617 15.0137 4.51701C14.9005 4.30784 14.7164 4.14587 14.4945 4.06019C14.2726 3.9745 14.0275 3.9707 13.8031 4.04948C13.5786 4.12825 13.3896 4.28444 13.27 4.49L10.82 4C10.7799 3.99121 10.7385 3.99046 10.6982 3.99779C10.6578 4.00513 10.6193 4.0204 10.5849 4.04272C10.5505 4.06505 10.5208 4.09398 10.4977 4.12784C10.4745 4.16171 10.4583 4.19983 10.45 4.24L9.71 7.71C8.31788 7.73099 6.96227 8.15853 5.81 8.94C5.65584 8.79495 5.47199 8.68516 5.27118 8.61823C5.07037 8.5513 4.85741 8.52883 4.64705 8.55239C4.4367 8.57594 4.23398 8.64496 4.05295 8.75464C3.87192 8.86433 3.7169 9.01207 3.59864 9.18762C3.48038 9.36317 3.40171 9.56234 3.36808 9.77132C3.33444 9.9803 3.34665 10.1941 3.40385 10.3979C3.46106 10.6017 3.56189 10.7906 3.69936 10.9515C3.83683 11.1125 4.00766 11.2416 4.2 11.33C4.18874 11.4765 4.18874 11.6235 4.2 11.77C4.2 14.01 6.81 15.83 10.03 15.83C13.25 15.83 15.86 14.01 15.86 11.77C15.8713 11.6235 15.8713 11.4765 15.86 11.33C16.1068 11.2073 16.3138 11.0174 16.4571 10.782C16.6005 10.5467 16.6743 10.2755 16.67 10V10ZM6.67 11C6.67 10.7348 6.77536 10.4804 6.96289 10.2929C7.15043 10.1054 7.40478 10 7.67 10C7.93522 10 8.18957 10.1054 8.37711 10.2929C8.56464 10.4804 8.67 10.7348 8.67 11C8.67 11.2652 8.56464 11.5196 8.37711 11.7071C8.18957 11.8946 7.93522 12 7.67 12C7.40478 12 7.15043 11.8946 6.96289 11.7071C6.77536 11.5196 6.67 11.2652 6.67 11ZM12.48 13.75C11.7705 14.2847 10.8976 14.5568 10.01 14.52C9.12239 14.5568 8.24948 14.2847 7.54 13.75C7.49748 13.6982 7.47575 13.6324 7.47903 13.5655C7.48232 13.4985 7.51039 13.4352 7.55779 13.3878C7.60519 13.3404 7.66852 13.3123 7.73546 13.309C7.80241 13.3057 7.86819 13.3275 7.92 13.37C8.52123 13.811 9.25512 14.0333 10 14C10.7458 14.0406 11.4831 13.8254 12.09 13.39C12.1156 13.3614 12.1468 13.3383 12.1816 13.3222C12.2165 13.3061 12.2543 13.2974 12.2927 13.2965C12.3311 13.2957 12.3693 13.3028 12.4048 13.3173C12.4404 13.3318 12.4725 13.3535 12.4993 13.381C12.5262 13.4085 12.547 13.4412 12.5606 13.4771C12.5743 13.513 12.5804 13.5514 12.5786 13.5897C12.5767 13.6281 12.5671 13.6656 12.5501 13.7001C12.5331 13.7346 12.5093 13.7652 12.48 13.79V13.75V13.75ZM12.3 12.04C12.1022 12.04 11.9089 11.9814 11.7444 11.8715C11.58 11.7616 11.4518 11.6054 11.3761 11.4227C11.3004 11.24 11.2806 11.0389 11.3192 10.8449C11.3578 10.6509 11.453 10.4727 11.5929 10.3329C11.7327 10.193 11.9109 10.0978 12.1049 10.0592C12.2989 10.0206 12.5 10.0404 12.6827 10.1161C12.8654 10.1918 13.0216 10.32 13.1315 10.4844C13.2414 10.6489 13.3 10.8422 13.3 11.04C13.3054 11.1755 13.2832 11.3107 13.2348 11.4373C13.1864 11.564 13.1127 11.6795 13.0182 11.7767C12.9237 11.874 12.8104 11.9511 12.6853 12.0032C12.5601 12.0553 12.4256 12.0815 12.29 12.08L12.3 12.04Z"
        })
    });
};
/* harmony default export */ var redditIcon = (RedditIcon);

;// CONCATENATED MODULE: ./src/components/Icons/instagramIcon.tsx



const InstagramIcon = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
        fill: "currentcolor",
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10 0C12.717 0 13.056 0.00999994 14.122 0.0599999C15.187 0.11 15.912 0.277 16.55 0.525C17.21 0.779 17.766 1.123 18.322 1.678C18.8305 2.1779 19.224 2.78259 19.475 3.45C19.722 4.087 19.89 4.813 19.94 5.878C19.987 6.944 20 7.283 20 10C20 12.717 19.99 13.056 19.94 14.122C19.89 15.187 19.722 15.912 19.475 16.55C19.2247 17.2178 18.8311 17.8226 18.322 18.322C17.822 18.8303 17.2173 19.2238 16.55 19.475C15.913 19.722 15.187 19.89 14.122 19.94C13.056 19.987 12.717 20 10 20C7.283 20 6.944 19.99 5.878 19.94C4.813 19.89 4.088 19.722 3.45 19.475C2.78233 19.2245 2.17753 18.8309 1.678 18.322C1.16941 17.8222 0.775931 17.2175 0.525 16.55C0.277 15.913 0.11 15.187 0.0599999 14.122C0.0129999 13.056 0 12.717 0 10C0 7.283 0.00999994 6.944 0.0599999 5.878C0.11 4.812 0.277 4.088 0.525 3.45C0.775236 2.78218 1.1688 2.17732 1.678 1.678C2.17767 1.16923 2.78243 0.775729 3.45 0.525C4.088 0.277 4.812 0.11 5.878 0.0599999C6.944 0.0129999 7.283 0 10 0ZM10 5C8.67392 5 7.40215 5.52678 6.46447 6.46447C5.52678 7.40215 5 8.67392 5 10C5 11.3261 5.52678 12.5979 6.46447 13.5355C7.40215 14.4732 8.67392 15 10 15C11.3261 15 12.5979 14.4732 13.5355 13.5355C14.4732 12.5979 15 11.3261 15 10C15 8.67392 14.4732 7.40215 13.5355 6.46447C12.5979 5.52678 11.3261 5 10 5V5ZM16.5 4.75C16.5 4.41848 16.3683 4.10054 16.1339 3.86612C15.8995 3.6317 15.5815 3.5 15.25 3.5C14.9185 3.5 14.6005 3.6317 14.3661 3.86612C14.1317 4.10054 14 4.41848 14 4.75C14 5.08152 14.1317 5.39946 14.3661 5.63388C14.6005 5.8683 14.9185 6 15.25 6C15.5815 6 15.8995 5.8683 16.1339 5.63388C16.3683 5.39946 16.5 5.08152 16.5 4.75ZM10 7C10.7956 7 11.5587 7.31607 12.1213 7.87868C12.6839 8.44129 13 9.20435 13 10C13 10.7956 12.6839 11.5587 12.1213 12.1213C11.5587 12.6839 10.7956 13 10 13C9.20435 13 8.44129 12.6839 7.87868 12.1213C7.31607 11.5587 7 10.7956 7 10C7 9.20435 7.31607 8.44129 7.87868 7.87868C8.44129 7.31607 9.20435 7 10 7V7Z"
        })
    });
};
/* harmony default export */ var instagramIcon = (InstagramIcon);

;// CONCATENATED MODULE: ./src/components/Icons/facebookIcon.tsx



const FacebookIcon = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
        viewBox: "0 0 20 20",
        fill: "currentcolor",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10 0C4.477 0 0 4.477 0 10C0 14.991 3.657 19.128 8.438 19.879V12.89H5.898V10H8.438V7.797C8.438 5.291 9.93 3.907 12.215 3.907C13.309 3.907 14.453 4.102 14.453 4.102V6.562H13.193C11.95 6.562 11.563 7.333 11.563 8.124V10H14.336L13.893 12.89H11.563V19.879C16.343 19.129 20 14.99 20 10C20 4.477 15.523 0 10 0Z"
        })
    });
};
/* harmony default export */ var facebookIcon = (FacebookIcon);

;// CONCATENATED MODULE: ./src/components/Icons/githubIcon.tsx



const GithubIcon = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
        fill: "currentcolor",
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10 0C4.475 0 1.45954e-06 4.475 1.45954e-06 10C-0.00113276 12.0993 0.658815 14.1456 1.88622 15.8487C3.11362 17.5517 4.84615 18.8251 6.838 19.488C7.338 19.575 7.525 19.275 7.525 19.012C7.525 18.775 7.512 17.988 7.512 17.15C5 17.613 4.35 16.538 4.15 15.975C4.037 15.687 3.55 14.8 3.125 14.562C2.775 14.375 2.275 13.912 3.112 13.9C3.9 13.887 4.462 14.625 4.65 14.925C5.55 16.437 6.988 16.012 7.562 15.75C7.65 15.1 7.912 14.663 8.2 14.413C5.975 14.163 3.65 13.3 3.65 9.475C3.65 8.387 4.037 7.488 4.675 6.787C4.575 6.537 4.225 5.512 4.775 4.137C4.775 4.137 5.612 3.875 7.525 5.163C8.33906 4.93706 9.18017 4.82334 10.025 4.825C10.875 4.825 11.725 4.937 12.525 5.162C14.437 3.862 15.275 4.138 15.275 4.138C15.825 5.513 15.475 6.538 15.375 6.788C16.012 7.488 16.4 8.375 16.4 9.475C16.4 13.313 14.063 14.163 11.838 14.413C12.2 14.725 12.513 15.325 12.513 16.263C12.513 17.6 12.5 18.675 12.5 19.013C12.5 19.275 12.688 19.587 13.188 19.487C15.173 18.8168 16.8979 17.541 18.1199 15.8392C19.3419 14.1373 19.9994 12.0951 20 10C20 4.475 15.525 0 10 0Z"
        })
    });
};
/* harmony default export */ var githubIcon = (GithubIcon);

;// CONCATENATED MODULE: ./src/components/Icons/telegramIcon.tsx



const TelegramIcon = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
        viewBox: "0 0 20 20",
        fill: "currentcolor",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM6.89 11.17L6.903 11.163L7.773 14.033C7.885 14.344 8.039 14.4 8.226 14.374C8.414 14.349 8.513 14.248 8.636 14.13L9.824 12.982L12.374 14.87C12.84 15.127 13.175 14.994 13.291 14.438L14.948 6.616C15.131 5.888 14.811 5.596 14.246 5.828L4.513 9.588C3.849 9.854 3.853 10.226 4.393 10.391L6.89 11.171V11.17Z"
        })
    });
};
/* harmony default export */ var telegramIcon = (TelegramIcon);

;// CONCATENATED MODULE: ./src/components/Icons/openseaicon.tsx



const OpenseaIcon = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Icon */.JO, {
        fill: "currentcolor",
        ...props,
        width: "21px !important",
        height: "21px !important",
        viewBox: "0 0 25 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_9057_69105)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M24.668 12C24.668 18.627 19.295 24 12.668 24C6.04092 24 0.667969 18.627 0.667969 12C0.667969 5.37295 6.04092 0 12.668 0C19.2964 0 24.668 5.37295 24.668 12Z",
                        fill: "#1A202C"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.68638 11.8575L6.74195 11.7868L10.0931 7.54296C10.1421 7.48082 10.2573 7.48725 10.2943 7.55474C10.8542 8.57043 11.3372 9.83362 11.1109 10.62C11.0143 10.9436 10.7496 11.3818 10.4518 11.7868C10.4134 11.8457 10.3711 11.9036 10.3261 11.9593C10.3049 11.985 10.2692 12 10.2308 12H6.78431C6.69166 12 6.6374 11.9186 6.68638 11.8575Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.168 13.1288V13.9125C20.168 13.9575 20.1405 13.9975 20.1005 14.015C19.8555 14.12 19.0167 14.505 18.668 14.99C17.778 16.2287 17.098 18 15.578 18H9.23671C6.98923 18 5.16797 16.1725 5.16797 13.9175V13.845C5.16797 13.785 5.21671 13.7363 5.27671 13.7363H8.81173C8.88171 13.7363 8.93296 13.8013 8.92673 13.87C8.90171 14.1 8.94422 14.335 9.05297 14.5487C9.26296 14.975 9.69797 15.2413 10.168 15.2413H11.918V13.875H10.188C10.0992 13.875 10.0467 13.7725 10.098 13.7C10.1167 13.6712 10.138 13.6413 10.1605 13.6075C10.3242 13.375 10.558 13.0138 10.7905 12.6025C10.9492 12.325 11.103 12.0288 11.2267 11.7313C11.2517 11.6775 11.2717 11.6225 11.2917 11.5687C11.3255 11.4737 11.3605 11.385 11.3855 11.2963C11.4105 11.2212 11.4305 11.1425 11.4505 11.0687C11.5092 10.8162 11.5342 10.5487 11.5342 10.2712C11.5342 10.1625 11.5292 10.0487 11.5192 9.94C11.5142 9.82126 11.4992 9.70249 11.4842 9.58374C11.4742 9.47874 11.4555 9.37499 11.4355 9.26624C11.4105 9.1075 11.3755 8.95001 11.3355 8.79124L11.3217 8.73126C11.2917 8.62249 11.2667 8.51876 11.2317 8.41001C11.133 8.06874 11.0192 7.73625 10.8992 7.42501C10.8555 7.30125 10.8055 7.1825 10.7555 7.06376C10.6817 6.88501 10.6067 6.72251 10.538 6.56875C10.503 6.49874 10.473 6.43499 10.443 6.37C10.4092 6.29624 10.3742 6.22249 10.3392 6.15251C10.3142 6.09876 10.2855 6.04875 10.2655 5.99875L10.0517 5.60375C10.0217 5.55 10.0717 5.48624 10.1305 5.5025L11.468 5.86499H11.4717C11.4742 5.86499 11.4755 5.86625 11.4767 5.86625L11.653 5.91499L11.8467 5.97001L11.918 5.98999V5.195C11.918 4.81124 12.2255 4.5 12.6055 4.5C12.7955 4.5 12.968 4.5775 13.0917 4.70374C13.2155 4.83001 13.293 5.0025 13.293 5.195V6.37501L13.4355 6.41499C13.4467 6.41876 13.458 6.42375 13.468 6.43124C13.503 6.4575 13.553 6.49624 13.6167 6.54376C13.6667 6.58374 13.7205 6.6325 13.7855 6.68251C13.9142 6.78624 14.068 6.92 14.2367 7.07376C14.2817 7.1125 14.3255 7.1525 14.3655 7.19251C14.583 7.39501 14.8267 7.6325 15.0592 7.895C15.1242 7.96876 15.188 8.04375 15.253 8.12249C15.318 8.2025 15.3867 8.28124 15.4467 8.36001C15.5255 8.465 15.6105 8.57375 15.6842 8.68751C15.7192 8.74126 15.7592 8.79625 15.793 8.85C15.888 8.99374 15.9717 9.14251 16.0517 9.29126C16.0855 9.36 16.1205 9.43499 16.1505 9.50875C16.2392 9.7075 16.3092 9.91 16.3542 10.1125C16.368 10.1563 16.378 10.2038 16.383 10.2463V10.2563C16.398 10.3162 16.403 10.38 16.408 10.445C16.428 10.6525 16.418 10.86 16.373 11.0687C16.3542 11.1575 16.3292 11.2412 16.2992 11.33C16.2692 11.415 16.2392 11.5037 16.2005 11.5875C16.1255 11.7612 16.0367 11.935 15.9317 12.0975C15.898 12.1575 15.858 12.2213 15.818 12.2813C15.7742 12.345 15.7292 12.405 15.6892 12.4638C15.6342 12.5388 15.5755 12.6175 15.5155 12.6875C15.4617 12.7613 15.4067 12.835 15.3467 12.9C15.263 12.9987 15.183 13.0925 15.0992 13.1825C15.0492 13.2412 14.9955 13.3013 14.9405 13.355C14.8867 13.415 14.8317 13.4687 14.7817 13.5187C14.698 13.6025 14.628 13.6675 14.5692 13.7212L14.4317 13.8475C14.4117 13.865 14.3855 13.875 14.358 13.875H13.293V15.2413H14.633C14.933 15.2413 15.218 15.135 15.448 14.94C15.5267 14.8713 15.8705 14.5738 16.2767 14.125C16.2905 14.11 16.308 14.0987 16.328 14.0938L20.0292 13.0238C20.098 13.0038 20.168 13.0562 20.168 13.1288Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_9057_69105",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white",
                        transform: "translate(0.667969)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var openseaicon = (OpenseaIcon);

// EXTERNAL MODULE: ./node_modules/@everipedia/iq-utils/build/module/index.js + 2 modules
var build_module = __webpack_require__("./node_modules/@everipedia/iq-utils/build/module/index.js");
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__("./node_modules/react-icons/fa/index.esm.js");
;// CONCATENATED MODULE: ./src/components/Icons/emailIcon.tsx



const EmailIcon = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
        viewBox: "0 0 20 20",
        fill: "currentcolor",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1 0H19C19.2652 0 19.5196 0.105357 19.7071 0.292893C19.8946 0.48043 20 0.734784 20 1V17C20 17.2652 19.8946 17.5196 19.7071 17.7071C19.5196 17.8946 19.2652 18 19 18H1C0.734784 18 0.48043 17.8946 0.292893 17.7071C0.105357 17.5196 0 17.2652 0 17V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0V0ZM10.06 8.683L3.648 3.238L2.353 4.762L10.073 11.317L17.654 4.757L16.346 3.244L10.061 8.683H10.06Z"
        })
    });
};
/* harmony default export */ var emailIcon = (EmailIcon);

;// CONCATENATED MODULE: ./src/components/Icons/discordIcon.tsx



const DiscordIcon = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
        fill: "currentcolor",
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.20881 9.86816C7.80881 9.86816 8.29481 10.3182 8.28381 10.8682C8.28381 11.4182 7.80981 11.8682 7.20881 11.8682C6.61881 11.8682 6.13281 11.4182 6.13281 10.8682C6.13281 10.3182 6.60781 9.86816 7.20881 9.86816ZM11.0568 9.86816C11.6578 9.86816 12.1328 10.3182 12.1328 10.8682C12.1328 11.4182 11.6578 11.8682 11.0568 11.8682C10.4668 11.8682 9.98181 11.4182 9.98181 10.8682C9.98181 10.3182 10.4558 9.86816 11.0568 9.86816ZM16.0238 0.868164C17.1868 0.868164 18.1328 1.83416 18.1328 3.03116V21.8682L15.9218 19.8732L14.6768 18.6972L13.3598 17.4472L13.9058 19.3902H2.24181C1.07881 19.3902 0.132812 18.4242 0.132812 17.2272V3.03116C0.132812 1.83416 1.07881 0.868164 2.24181 0.868164H16.0228H16.0238ZM12.0538 14.5812C14.3268 14.5082 15.2018 12.9852 15.2018 12.9852C15.2018 9.60416 13.7198 6.86316 13.7198 6.86316C12.2398 5.73016 10.8298 5.76116 10.8298 5.76116L10.6858 5.92916C12.4348 6.47516 13.2468 7.26316 13.2468 7.26316C12.2919 6.72515 11.2395 6.3825 10.1508 6.25516C9.46025 6.17717 8.76274 6.18388 8.07381 6.27516C8.01181 6.27516 7.95981 6.28616 7.89881 6.29616C7.53881 6.32816 6.66381 6.46416 5.56381 6.95816C5.18381 7.13616 4.95681 7.26316 4.95681 7.26316C4.95681 7.26316 5.81081 6.43316 7.66181 5.88716L7.55881 5.76116C7.55881 5.76116 6.14981 5.73016 4.66881 6.86416C4.66881 6.86416 3.18781 9.60416 3.18781 12.9852C3.18781 12.9852 4.05181 14.5072 6.32481 14.5812C6.32481 14.5812 6.70481 14.1092 7.01481 13.7102C5.70781 13.3102 5.21481 12.4702 5.21481 12.4702C5.21481 12.4702 5.31681 12.5442 5.50181 12.6492C5.51181 12.6592 5.52181 12.6702 5.54281 12.6802C5.57381 12.7022 5.60481 12.7122 5.63581 12.7332C5.89281 12.8802 6.14981 12.9952 6.38581 13.0902C6.80781 13.2582 7.31181 13.4262 7.89881 13.5422C8.77813 13.7145 9.68222 13.7179 10.5628 13.5522C11.0757 13.4606 11.5761 13.3092 12.0538 13.1012C12.4138 12.9642 12.8148 12.7642 13.2368 12.4812C13.2368 12.4812 12.7228 13.3422 11.3748 13.7312C11.6838 14.1302 12.0548 14.5812 12.0548 14.5812H12.0538Z",
            fill: "#4A5568"
        })
    });
};
/* harmony default export */ var discordIcon = (DiscordIcon);

// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
;// CONCATENATED MODULE: ./src/data/WikiLinks.ts















const LinkType = {
    WEBSITE: "website",
    SOCIAL: "social",
    CONTRACT: "contract",
    EXPLORER: "explorer"
};
const LINK_OPTIONS = [
    {
        id: build_module/* CommonMetaIds.REDDIT_URL */.wA.REDDIT_URL,
        type: LinkType.SOCIAL,
        label: "Reddit",
        icon: redditIcon,
        tests: [
            /https:\/\/www\.reddit\.com\/r\//i
        ]
    },
    {
        id: build_module/* CommonMetaIds.DISCORD_PROFILE */.wA.DISCORD_PROFILE,
        type: LinkType.SOCIAL,
        label: "Discord",
        icon: discordIcon,
        tests: [
            /https:\/\/discord\.(gg|com)\//i
        ]
    },
    {
        id: build_module/* CommonMetaIds.EMAIL_URL */.wA.EMAIL_URL,
        type: LinkType.SOCIAL,
        label: "Email",
        icon: emailIcon,
        tests: [
            /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/
        ]
    },
    {
        id: build_module/* CommonMetaIds.GITHUB_URL */.wA.GITHUB_URL,
        type: LinkType.SOCIAL,
        label: "Github",
        icon: githubIcon,
        tests: [
            /https:\/\/github\.com\//i
        ]
    },
    {
        id: build_module/* CommonMetaIds.TELEGRAM_URL */.wA.TELEGRAM_URL,
        type: LinkType.SOCIAL,
        label: "Telegram",
        icon: telegramIcon,
        tests: [
            /https:\/\/t\.me\//i
        ]
    },
    {
        id: build_module/* CommonMetaIds.INSTAGRAM_PROFILE */.wA.INSTAGRAM_PROFILE,
        type: LinkType.SOCIAL,
        label: "Instagram",
        icon: instagramIcon,
        tests: [
            /https:\/\/(www.)?instagram.com\/\w+/
        ]
    },
    {
        id: build_module/* CommonMetaIds.TWITTER_PROFILE */.wA.TWITTER_PROFILE,
        type: LinkType.SOCIAL,
        label: "Twitter",
        icon: twitterIcon,
        tests: [
            /https:\/\/(www.)?twitter.com\/\w+/
        ]
    },
    {
        id: build_module/* CommonMetaIds.LINKEDIN_PROFILE */.wA.LINKEDIN_PROFILE,
        type: LinkType.SOCIAL,
        label: "Linkedin",
        icon: index_esm/* AiFillLinkedin */._iD,
        tests: [
            /https:\/\/(www.)?linkedin.com\/(in|company)\/\w+/
        ]
    },
    {
        id: build_module/* CommonMetaIds.YOUTUBE_PROFILE */.wA.YOUTUBE_PROFILE,
        type: LinkType.SOCIAL,
        label: "Youtube",
        icon: index_esm/* AiFillYoutube */.b1v,
        tests: [
            /https:\/\/(www.)?youtube.com\/\w+/
        ]
    },
    {
        id: build_module/* CommonMetaIds.FACEBOOK_PROFILE */.wA.FACEBOOK_PROFILE,
        type: LinkType.SOCIAL,
        label: "Facebook",
        icon: facebookIcon,
        tests: [
            /https:\/\/(www.)?((web|m).)?facebook.com\/\w+/
        ]
    },
    {
        id: build_module/* CommonMetaIds.COINGECKO_PROFILE */.wA.COINGECKO_PROFILE,
        type: LinkType.SOCIAL,
        label: "Coingecko",
        icon: coingecko,
        tests: [
            /https:\/\/(www.)?coingecko.com\/en\/(nft|coins)\/(.+)/
        ]
    },
    {
        id: build_module/* CommonMetaIds.COIN_MARKET_CAP */.wA.COIN_MARKET_CAP,
        type: LinkType.SOCIAL,
        label: "Coin Market Cap",
        icon: coinmarketcap,
        tests: [
            /https:\/\/coinmarketcap\.com\/currencies\//i
        ]
    },
    {
        id: build_module/* CommonMetaIds.OPENSEA_PROFILE */.wA.OPENSEA_PROFILE,
        type: LinkType.SOCIAL,
        label: "Opensea",
        icon: openseaicon,
        tests: [
            /https:\/\/opensea\.io\/\w+/
        ]
    },
    {
        id: build_module/* CommonMetaIds.MEDIUM_PROFILE */.wA.MEDIUM_PROFILE,
        type: LinkType.SOCIAL,
        label: "Medium",
        icon: ri_index_esm/* RiMediumFill */.sG0,
        tests: [
            /^https?:\/\/(([a-zA-Z0-9]+)\.(medium\.com)|medium\.com\/([a-zA-Z0-9-]+)|medium\.com\/@([A-Za-z0-9]+))\/?$/
        ]
    },
    {
        id: build_module/* CommonMetaIds.WEBSITE */.wA.WEBSITE,
        type: LinkType.WEBSITE,
        label: "Website",
        icon: ri_index_esm/* RiGlobalFill */.nwJ,
        tests: [
            /https:\/\/(www.)?\w+.\w+/
        ]
    },
    {
        id: build_module/* CommonMetaIds.CONTRACT_URL */.wA.CONTRACT_URL,
        type: LinkType.CONTRACT,
        label: "Contract URL",
        icon: fa_index_esm/* FaFileContract */.UCj,
        tests: [
            /i/
        ]
    },
    {
        id: build_module/* CommonMetaIds.ETHERSCAN_PROFILE */.wA.ETHERSCAN_PROFILE,
        type: LinkType.EXPLORER,
        label: "Etherscan",
        icon: fa_index_esm/* FaFileContract */.UCj,
        tests: [
            /https:\/\/(www.)?etherscan.io\/\w+/
        ]
    },
    {
        id: build_module/* CommonMetaIds.BSCSCAN_PROFILE */.wA.BSCSCAN_PROFILE,
        type: LinkType.EXPLORER,
        label: "BscScan",
        icon: fa_index_esm/* FaFileContract */.UCj,
        tests: [
            /https:\/\/(www.)?bscscan.com\/\w+/
        ]
    },
    {
        id: build_module/* CommonMetaIds.ARBISCAN_PROFILE */.wA.ARBISCAN_PROFILE,
        type: LinkType.EXPLORER,
        label: "Arbiscan",
        icon: fa_index_esm/* FaFileContract */.UCj,
        tests: [
            /https:\/\/(www.)?arbiscan.io\/\w+/
        ]
    },
    {
        id: build_module/* CommonMetaIds.POLYGONSCAN_PROFILE */.wA.POLYGONSCAN_PROFILE,
        type: LinkType.EXPLORER,
        label: "Polygonscan",
        icon: fa_index_esm/* FaFileContract */.UCj,
        tests: [
            /https:\/\/(www.)?polygonscan.com\/\w+/
        ]
    },
    {
        id: build_module/* CommonMetaIds.OPTIMISTIC_ETHERSCAN_PROFILE */.wA.OPTIMISTIC_ETHERSCAN_PROFILE,
        type: LinkType.EXPLORER,
        label: "Optimistic Etherscan",
        icon: fa_index_esm/* FaFileContract */.UCj,
        tests: [
            /https:\/\/(www.)?optimistic.etherscan.io\/\w+/
        ]
    }
];


/***/ }),

/***/ "./src/store/hook.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useAppSelector; },
/* harmony export */   "T": function() { return /* binding */ useAppDispatch; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react-redux/es/index.js");

const useAppDispatch = ()=>(0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
const useAppSelector = react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9;


/***/ }),

/***/ "./src/utils/DataTransform/getFormattedDate.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getReadableDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/date-fns/esm/formatDistanceToNowStrict/index.js");

const getReadableDate = (dateToFormat)=>{
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(dateToFormat), {
        addSuffix: false
    });
};


/***/ }),

/***/ "./src/utils/DataTransform/getUsername.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ getUsername; }
/* harmony export */ });
/* harmony import */ var _textUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/utils/textUtils.ts");

const getUsername = (user, ensDomain)=>{
    var ref;
    if (!user) {
        return "Unknown";
    }
    if ((ref = user.profile) === null || ref === void 0 ? void 0 : ref.username) {
        return user.profile.username;
    }
    if (ensDomain) {
        return ensDomain;
    }
    return user.id ? (0,_textUtils__WEBPACK_IMPORTED_MODULE_0__/* .shortenAccount */ .p0)(user.id) : "Unknown";
};


/***/ }),

/***/ "./src/utils/DataTransform/mediaUtils.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ checkMediaDefaultId; },
/* harmony export */   "w": function() { return /* binding */ constructMediaUrl; }
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/config/index.ts");
/* harmony import */ var _data_Constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/data/Constants.ts");


const VIMEO_DEFAULT_URL = "https://vimeo.com/";
const checkMediaDefaultId = (id)=>{
    return id.includes(_data_Constants__WEBPACK_IMPORTED_MODULE_1__/* .MEDIA_POST_DEFAULT_ID */ .ft);
};
const constructMediaUrl = (media)=>{
    let url;
    switch(media.source){
        case "YOUTUBE":
            url = "https://i3.ytimg.com/vi/".concat(media.id, "/maxresdefault.jpg");
            break;
        case "VIMEO":
            url = VIMEO_DEFAULT_URL + media.id;
            break;
        default:
            url = "".concat(_config__WEBPACK_IMPORTED_MODULE_0__/* ["default"].pinataBaseUrl */ .Z.pinataBaseUrl).concat(media.id);
    }
    return url;
};


/***/ }),

/***/ "./src/utils/WikiUtils/getWikiFields.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CC": function() { return /* binding */ getActivityMetadataById; },
/* harmony export */   "lU": function() { return /* binding */ getWikiMetadataById; }
/* harmony export */ });
/* unused harmony export getCategoryById */
const getWikiMetadataById = (wiki, id)=>wiki.metadata.find((m)=>m.id === id);
const getActivityMetadataById = (activity, id)=>activity.content[0].metadata.find((m)=>m.id === id);
const getCategoryById = (wiki, id)=>wiki.categories.find((c)=>c.id === id);


/***/ }),

/***/ "./src/utils/WikiUtils/getWikiImageUrl.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getWikiImageUrl; }
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/config/index.ts");

const getWikiImageUrl = (imageObj)=>{
    var ref;
    return "".concat(_config__WEBPACK_IMPORTED_MODULE_0__/* ["default"].pinataBaseUrl */ .Z.pinataBaseUrl).concat(imageObj ? (ref = imageObj[0]) === null || ref === void 0 ? void 0 : ref.id : "");
};


/***/ }),

/***/ "./src/utils/textUtils.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ei": function() { return /* binding */ slugifyText; },
/* harmony export */   "El": function() { return /* binding */ shortenText; },
/* harmony export */   "TY": function() { return /* binding */ lettersToNum; },
/* harmony export */   "Zw": function() { return /* binding */ isVerifiedContentLinks; },
/* harmony export */   "jv": function() { return /* binding */ isValidUrl; },
/* harmony export */   "lK": function() { return /* binding */ shortenBalance; },
/* harmony export */   "p0": function() { return /* binding */ shortenAccount; }
/* harmony export */ });
/* unused harmony export shortenMediaText */
/* harmony import */ var _everipedia_iq_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/@everipedia/iq-utils/build/module/index.js");
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/slugify/slugify.js");
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(slugify__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var humanize_plus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/humanize-plus/dist/humanize.js");
/* harmony import */ var humanize_plus__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(humanize_plus__WEBPACK_IMPORTED_MODULE_2__);



const lettersToNum = (str)=>{
    let out = 0;
    const len = str.length;
    for(let pos = 0; pos < len; pos += 1){
        out += (str.charCodeAt(pos) - 64) * 26 ** (len - pos - 1);
    }
    return out;
};
const shortenAccount = function(account) {
    let firstTakeLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, secondTakeLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 4;
    const firstChunk = account.substring(0, firstTakeLength);
    const secondChunk = account.substring(account.length - secondTakeLength);
    return "".concat(firstChunk, "...").concat(secondChunk);
};
const shortenBalance = (balance)=>typeof balance === "number" ? humanize_plus__WEBPACK_IMPORTED_MODULE_2__.formatNumber(balance, 2) : balance;
const shortenText = (text, length)=>{
    return (text === null || text === void 0 ? void 0 : text.length) > length ? "".concat(text.substring(0, length), "...") : text;
};
const shortenMediaText = (name)=>{
    const nameArray = name.split(".");
    return nameArray[0].length > 6 ? "".concat(nameArray[0].substring(0, 6), "....").concat(nameArray[1]) : name;
};
const slugifyText = (text)=>{
    return slugify__WEBPACK_IMPORTED_MODULE_1___default()(text.toLowerCase(), {
        strict: true,
        lower: true,
        remove: /[*+~.()'"!:@]/g
    });
};
const isValidUrl = (urlString)=>{
    try {
        return Boolean(new URL(urlString));
    } catch (_e) {
        return false;
    }
};
const isVerifiedContentLinks = (content)=>{
    const markdownLinks = content.match(/\[(.*?)\]\((.*?)\)/g);
    let isValid = true;
    markdownLinks === null || markdownLinks === void 0 ? void 0 : markdownLinks.every((link)=>{
        const linkMatch = link.match(/\[(.*?)\]\((.*?)\)/);
        const text = linkMatch === null || linkMatch === void 0 ? void 0 : linkMatch[1];
        const url = linkMatch === null || linkMatch === void 0 ? void 0 : linkMatch[2];
        if (text && url && _everipedia_iq_utils__WEBPACK_IMPORTED_MODULE_0__/* .whiteListedLinkNames.includes */ .Kp.includes(text) && !isValidUrl(url)) {
            isValid = true;
            return true;
        }
        if (url && url.charAt(0) !== "#") {
            const validURLRecognizer = new RegExp("^https?://(www\\.)?(".concat(_everipedia_iq_utils__WEBPACK_IMPORTED_MODULE_0__/* .whiteListedDomains.join */ .xw.join("|"), ")"));
            isValid = validURLRecognizer.test(url);
            return isValid;
        }
        return true;
    });
    return isValid;
};


/***/ })

}]);